import React from 'react';
import ReactPlayer from 'react-player';

interface AudioAttachmentProps {
  audioUrl: string;
  onLoadOrError: (error: boolean) => void;
}

const Audio: React.FC<AudioAttachmentProps> = ({ audioUrl, onLoadOrError }) => (
  <ReactPlayer
    onError={() => {
      onLoadOrError(false);
    }}
    onReady={() => {
      onLoadOrError(true);
    }}
    height={24}
    className="task-attachment__item"
    url={audioUrl}
    playing
    controls
  />
);

export default Audio;
